import { IconButton, Snackbar } from '@material-ui/core';
import {
	CommonStatus,
	OrderStatus,
	useGetKitchenPrinterLazyQuery,
	useGetOrderLazyQuery,
	useGetOutletCustomerPolicyQuery,
	useGetPrinterOrderItemLazyQuery,
	useGetReceiptPrinterLazyQuery,
	useGetUsersByAccountAndSoftwareQuery,
} from 'generated/graphql';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { printReceiptText } from 'containers/OutletModule/Home/TableSubmenu/BillSettlement/BillReceipt/BillReceiptFunctions';
import {
	buildPerforatedSlipItems,
	printOrderReceiptRawViaLocalAgent,
} from 'services/localPrintAgentReceipt';
import CloseIcon from '@material-ui/icons/Close';
import { SocketContext } from 'containers/Socket/SocketContext';

export const PrinterWrapper = (props: any) => {
	const { socket }: any = useContext(SocketContext);
	const user = JSON.parse(localStorage.getItem('loggedInUser'));
	const printOutletID = localStorage.getItem('latestOutlet');
	const login = localStorage.getItem('login');

	const [open, setOpen] = useState(false);
	const [printOnce, setPrintOnce] = useState(false);
	const [socketPrintDataList, setSocketPrintDataList] = useState<any[]>([]);
	const [uniqueKpArray, setUniqueKpArray] = useState([]);
	const [uniqueKpInfoArray, setUniqueKpInfoArray] = useState([]);
	const [kpObj, setKpObject] = useState({});
	const [printerName, setPrinterName] = useState(null);
	const [kitchenPrinterObj, setKitchenPrinterObj] = useState([]);
	const [shouldQueryRun, setShouldQueryRun] = useState(false);

	const location = useLocation();

	const [
		loadkitchenPrinter,
		{
			loading: getKitchenPrinterLoading,
			data: { getKitchenPrinter } = { getKitchenPrinter: [] },
		},
	] = useGetKitchenPrinterLazyQuery({
		fetchPolicy: 'network-only',
	});

	const [
		loadPrinterOrderItem,
		{
			loading: getPrinterOrderItemLoading,
			data: { getPrinterOrderItem } = { getPrinterOrderItem: [] },
		},
	] = useGetPrinterOrderItemLazyQuery({
		fetchPolicy: 'network-only',
		onCompleted: () => {
			generateReceiptData();
		},
	});

	const [
		loadOrder,
		{ data: { getOrder } = { getOrder: [] } },
	] = useGetOrderLazyQuery({
		fetchPolicy: 'network-only',
		onCompleted: () => {
			setPrintOnce(true);
		},
	});

	const {
		data: { getOutletCustomerPolicy } = { getOutletCustomerPolicy: [] },
	} = useGetOutletCustomerPolicyQuery({
		skip: !printOutletID,
		fetchPolicy: 'network-only',
		variables: {
			outletID: printOutletID as string,
		},
	});

	const [
		loadReceiptPrinter,
		{ data: { getReceiptPrinter } = { getReceiptPrinter: [] } },
	] = useGetReceiptPrinterLazyQuery({
		fetchPolicy: 'network-only',
	});

	const path = location?.pathname;
	const isNotAuthPage = !['/login', '/logout', '/kitchen'].includes(path);

	useEffect(() => {
		if (!socket) return;

		const onSocketPrint = socketPrint => {
			try {
				if (socketPrint?.type === 'POST_PRINT_DATA') {
					if (
						isNotAuthPage &&
						socketPrint?.printData?.printerName &&
						socketPrint?.printData?.userID === user?.ID
					) {
						setSocketPrintDataList(prev => [
							...(Array.isArray(prev) ? prev : []),
							socketPrint?.printData,
						]);
						loadReceiptPrinter({
							variables: {
								isDefault: true,
								outletID: printOutletID,
							},
						});
						loadPrinterOrderItem({
							variables: {
								orderID: socketPrint?.printData?.orderID,
								orderItemIDs: socketPrint?.printData?.orderItemIDs,
							},
						});
						loadOrder({
							variables: {
								ID: socketPrint?.printData?.orderID,
								status: OrderStatus.Open,
								outletID: printOutletID,
							},
						});
					}
				}
			} catch (err) {
				console.error('Error handling print socket:', err);
			}
		};

		socket.off('socketPrint');
		socket.on('socketPrint', onSocketPrint);

		return () => {
			socket.off('socketPrint', onSocketPrint);
		};
	}, [socket]);

	useEffect(() => {
		if (getPrinterOrderItem?.length > 0) {
			generateReceiptData();
		}
	}, [getPrinterOrderItem]);

	const generateReceiptData = () => {
		let uniqueprinterName = new Set(
			getKitchenPrinter
				?.filter(kp => kpPlusID.has(kp?.ID))
				?.map(kp => kp?.name),
		);
		let uniqueprinterInfo = new Set(
			getPrinterOrderItem?.map(oi => oi?.menuItem?.kitchenPrinter),
		);
		setUniqueKpArray([...uniqueprinterName]);
		setUniqueKpInfoArray([...uniqueprinterInfo]);

		let temporaryObject: Record<string, any[]> = {};
		getPrinterOrderItem?.forEach(oi => {
			const printerName = oi?.menuItem?.kitchenPrinter?.name;
			if (!temporaryObject[printerName]) {
				temporaryObject[printerName] = [];
			}
			temporaryObject[printerName].push(oi);
		});
		setKpObject(temporaryObject);
	};

	const blockedRoutes = ['/login'];
	useEffect(() => {
		if (login && !blockedRoutes.includes(location.pathname)) {
			setShouldQueryRun(true);
		}
	}, [location.pathname]);

	const {
		data: { getUsersByAccountAndSoftware } = {
			getUsersByAccountAndSoftware: [],
		},
	} = useGetUsersByAccountAndSoftwareQuery({
		fetchPolicy: 'network-only',
		variables: {
			status: CommonStatus.Active,
		},
		skip: !shouldQueryRun,
	});

	let obj;
	const handlePrinting = async () => {
		if (uniqueKpArray?.length > 0) {
			let objArray: any = [];
			for (const printerName of uniqueKpArray) {
				const obj =
					kpObj[printerName] ?? kpObj[printerName || 'NonKitchenPrinter'] ?? [];
				objArray.push(...(Array.isArray(obj) ? obj : []));
				setKitchenPrinterObj(obj);
				setPrinterName(printerName || 'NonKitchenPrinter');
				const payload =
					socketPrintDataList?.find(
						(p: any) => p?.printerName === printerName,
					) ?? socketPrintDataList?.[0];
				const printData =
					payload?.printerConfigs?.find(
						(p: any) => p?.printerName === printerName,
					) ?? payload;
				const findPrinterInfo = uniqueKpInfoArray?.find(
					(info: any) => info?.name === printerName,
				);
				const isSDK =
					findPrinterInfo?.isSDK ?? printData?.isSDK ?? payload?.isSDK;
				const connectType =
					findPrinterInfo?.connectType ??
					printData?.connectType ??
					payload?.connectType;
				const deviceIP =
					findPrinterInfo?.deviceIP ??
					findPrinterInfo?.address ??
					payload?.deviceIP;
				const deviceAlignment =
					printData?.deviceAlignmentCode ??
					findPrinterInfo?.deviceAlignmentCode ??
					payload?.printerdeviceAlignmentCode;
				console.log('socket connectType', connectType);

				if (isSDK === true && connectType !== 'NETWORK') {
					await printReceiptText(
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						printerName,
						'server',
						null,
						'order-receipt',
						null,
						payload?.outletName,
						getOrder[0],
						getOrder[0]?.table,
						obj,
						payload?.orderMode,
						null,
						payload?.voidQuantity,
						payload?.reasonCode,
						payload?.remark,
						null,
						null,
						null,
						null,
						null,
						getUsersByAccountAndSoftware,
						null,
						null,
						null,
					);
				} else if (connectType === 'NETWORK') {
					try {
						await printOrderReceiptRawViaLocalAgent({
							outletName: payload?.outletName,
							orderData: getOrder[0],
							tableData: getOrder[0]?.table,
							orderItemData: obj,
							orderMode: payload?.orderMode,
							voidQuantity: payload?.voidQuantity,
							reasonCode: payload?.reasonCode,
							remark: payload?.remark,
							printerName: deviceIP,
							receiptType: 'order-receipt',
							width: deviceAlignment,
						});
					} catch (e) {
						console.warn(
							'Local Print Agent (order-receipt):',
							(e as Error)?.message ?? e,
						);
					}
				}
			}
			console.log(objArray, uniqueKpArray, 'kitchen1');
			if (getOutletCustomerPolicy[0]?.tableOrderPrint === true) {
				console?.log('hereprinter');
				if (socketPrintDataList[0]?.isSDK === true) {
					await printReceiptText(
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						null,
						getReceiptPrinter[0]?.name,
						'server',
						null,
						'guest-order-receipt',
						null,
						socketPrintDataList[0]?.outletName,
						getOrder[0],
						getOrder[0]?.table,
						objArray,
						socketPrintDataList[0]?.orderMode,
						null,
						socketPrintDataList[0]?.voidQuantity,
						socketPrintDataList[0]?.reasonCode,
						socketPrintDataList[0]?.remark,
						null,
						null,
						null,
						null,
						null,
						getUsersByAccountAndSoftware,
						null,
						null,
						null,
					);
				} else if (
					socketPrintDataList[0]?.isSDK === false &&
					socketPrintDataList[0]?.connectType === 'NETWORK'
				) {
					try {
						await printOrderReceiptRawViaLocalAgent({
							outletName: socketPrintDataList[0]?.outletName,
							orderData: getOrder[0],
							tableData: getOrder[0]?.table,
							orderItemData: objArray,
							orderMode: socketPrintDataList[0]?.orderMode,
							voidQuantity: socketPrintDataList[0]?.voidQuantity,
							reasonCode: socketPrintDataList[0]?.reasonCode,
							remark: socketPrintDataList[0]?.remark,
							printerName: getReceiptPrinter[0]?.deviceIP,
							receiptType: 'guest-order-receipt',
							width: getReceiptPrinter[0]?.deviceAlignmentCode,
						});
					} catch (e) {
						console.warn(
							'Local Print Agent (guest-order-receipt):',
							(e as Error)?.message ?? e,
						);
					}
				}
			}
		}
		setPrintOnce(false);
		setSocketPrintDataList([]);
		return true;
	};

	useEffect(() => {
		if (uniqueKpArray?.length > 0 && printOnce === true) {
			handlePrinting();
		}
	}, [printOnce]);

	const handleSnackbarClose = () => {
		setOpen(false);
	};

	return (
		<>
			{!getPrinterOrderItemLoading}
			<Snackbar
				className=""
				style={{ top: '10px', right: '10px' }}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				open={open}
				autoHideDuration={3000}
				onClose={() => setOpen(false)}
				ContentProps={{
					'aria-describedby': 'message-id',
					style: { backgroundColor: 'white', color: 'red' },
				}}
				message={<span id="message-id">Listening to print requests...</span>}
				action={
					<IconButton
						key="close"
						aria-label="close"
						color="inherit"
						onClick={handleSnackbarClose}
					>
						<CloseIcon />
					</IconButton>
				}
			/>
		</>
	);
};
